import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { DataSharingService } from "./data.share.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate { 
  constructor(private router: Router, private localStorage: DataSharingService) { }
 
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let token: any = null;
    try {
      const raw = this.localStorage.getItem('accessInfo');
      token = raw ? JSON.parse(raw) : null;
    } catch {
      token = null;
    }

    if (token && token.accessToken) {
      return true;
    } else { 
      this.localStorage.setItem('returnUrl', state.url); 

      // Redirigimos al usuario 
      this.router.navigate(['/auth/signin']); 
      return false;
    }
  }
}